// libraries
import { useTranslation } from 'react-i18next'

// components
import Breadcrumb from '../../components/Breadcrumb'

// assets
import metbuat_az from '../../../assets/img/metbuat.svg'
import metbuat_en from '../../../assets/img/metbuat_en.svg'
import metbuat_ru from '../../../assets/img/metbuat_ru.svg'

const Contact2 = () => {
    const { t, i18n } = useTranslation()
    const currentLang = i18n.language

    const breadcrumb = [
        {
            id: 1,
            link: "/elaqe/cagri-merkezi",
            title: t('contact:cagri'),
            isActive: false,
        },
        {
            id: 2,
            link: "/elaqe/elaqe-vasiteleri",
            title: t("contact:contact"),
            isActive: false,
        },
        {
            id: 3,
            link: "/elaqe/metbuat-xidmeti",
            title: t("contact:press"),
            isActive: true,
        },
        {
            id: 4,
            link: "/elaqe/en-cox-verilen-suallar",
            title: t("contact:faq"),
            isActive: false,
        },
    ];

    return (
        <div className="contact-page block-bg1 pt-lg-3 pb-3">
            <Breadcrumb data={breadcrumb} />

            <div className='container mt-5'>
                <div className='d-flex align-items-center flex-column'>
                    <h2>{t('contact:press_h')}</h2>
                    <div style={{ background: "#8CA2C2", height: "5px", width: "35%" }} className="rounded-5 mt-md-3 mt-2"></div>
                </div>
                <div className='mx-auto col-md-8 col-sm-10 col-12 mt-4 mb-5'>
                   {currentLang === 'az' && <img src={metbuat_az} className="w-100" alt='' />}
                   {currentLang === 'ru' && <img src={metbuat_ru} className="w-100" alt='' />}
                   {currentLang === 'en' && <img src={metbuat_en} className="w-100" alt='' />}
                </div>
            </div>
        </div>
    )
}

export default Contact2
